import "../styles/navbar.css";
import { NAV_LINKS } from "../data/constants";
import { logo } from "../assets/images";

export default function Navbar({ page, navigate }) {
  return (
    <nav className="navbar">
      <div className="navbar__inner">
        <div className="navbar__brand" onClick={() => navigate("Home")}>
          <img src={logo} alt="Race City Truck Solutions" className="navbar__brand-icon" />
        </div>
        <div className="navbar__links">
          {NAV_LINKS.map((l) => (
            <button
              key={l}
              className={"navbar__link" + (page === l ? " navbar__link--active" : "")}
              onClick={() => navigate(l)}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}